import { useEffect, useRef, useState } from "react";

export const useOverflowDetection = (showInDrawer, showMore) => {
  const divRef = useRef<HTMLDivElement>(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    if (divRef.current && showInDrawer) {
      const { offsetHeight, scrollHeight, offsetWidth, scrollWidth } =
        divRef.current;

      if (
        showMore &&
        (offsetHeight < scrollHeight || offsetWidth < scrollWidth)
      ) {
        setHasOverflow(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divRef, showInDrawer, showMore]);

  return { divRef, hasOverflow };
};
